var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gs-checkout-popup-note"},[_c('div',[_c('strong',[_vm._v("Use a GroovePages popup")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('frontend_groovesell_link_checkout_popup_modal_text', {pagesAppTitle: _vm.whitelabelAppData('pages').title}))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }